import { render, staticRenderFns } from "./OutbrineCard.vue?vue&type=template&id=9f763efa&scoped=true"
import script from "./OutbrineCard.vue?vue&type=script&lang=js"
export * from "./OutbrineCard.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "9f763efa",
  null
  
)

export default component.exports